/*
 *  Featured Collection Carousel
 *    Scripts for the Featured Collection Carousel section.
 *
 *  Version:
 *    1.0.0 - 2019/04/17
 */

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-featured-collection-carousel-container]';
export const CAROUSEL_SELECTOR = '[data-featured-collection-carousel]';
export const SELECTOR_PROGRESS_INNER = '[data-featured-collection-carousel-progress]';
export const IS_INFINITE = '[data-infinite]';
export const IS_AUTOPLAY = '[data-autoplay]';
export const IS_SPEED = '[data-autoplay-speed]';

export class FeaturedCarousel extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.infinite = container.find(IS_INFINITE);
    this.isInfinite = this.infinite.attr('data-infinite');
    this.autoplay= container.find(IS_AUTOPLAY);
    this.isAutoplay = this.infinite.attr('data-autoplay');
    this.speed= container.find(IS_SPEED);
    this.speed !== null ? this.isSpeed = parseInt(this.speed.attr('data-autoplay-speed')) * 1000 : 3000;
    this.progressBar = container.find(SELECTOR_PROGRESS_INNER);

    this.slick = this.initCarousel(this.carouselContainer);
    this.container.on('beforeChange', CAROUSEL_SELECTOR, (e, slick, currentSlide, nextSlide) => {
      this.updateProgress(slick, currentSlide, nextSlide);
    });
  }

  optionOverrides() {
    return {
      arrows: false,
      slidesToShow: 1.7,
      infinite: this.isInfinite === 'false' ? false : this.isInfinite === 'true' ? true : false,
      autoplay: this.isAutoplay === 'false' ? false : this.isAutoplay === 'true' ? true : false,
      autoplaySpeed: this.isSpeed,
      responsive: [
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 2.5, slidesToScroll: 1 }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 3.5, slidesToScroll: 1 }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: { slidesToShow: 5, swipeToSlide: false, centerMode: true }
        },
        {
          breakpoint: ResponsiveSizes.xlarge-1,
          settings: { slidesToShow: 5, swipeToSlide: false, centerMode: true }
        }
      ]
    }
  }

  updateProgress(slick, currentSlide, nextSlide) {
    let calc = ((nextSlide) / (slick.slideCount)) * 100;
    calc = (calc + (100 / slick.slideCount));
    this.progressBar.css('width', calc + '% ');
  }
}

register(CONTAINER_SELECTOR, FeaturedCarousel);
